import React from "react";
import { Check, AlertCircle } from "lucide-react";

export function KeywordMatch({ matched = [], missing = [], language }) {
  const L = language === "fr"
    ? { matched: "Mots-clés intégrés", missing: "À renforcer", none: "Aucune donnée pour le moment." }
    : { matched: "Matched keywords", missing: "To reinforce", none: "No data yet." };

  if (matched.length === 0 && missing.length === 0) {
    return <p className="text-sm text-[#525252] italic">{L.none}</p>;
  }

  return (
    <div className="space-y-4" data-testid="keyword-match">
      <div>
        <div className="flex items-center gap-2 mb-2">
          <Check size={14} className="text-[#059669]" />
          <span className="label-eyebrow">{L.matched} · {matched.length}</span>
        </div>
        <div className="flex flex-wrap gap-1.5">
          {matched.map((k, i) => (
            <span key={i} className="highlight-kw text-xs" data-testid={`kw-matched-${i}`}>{k}</span>
          ))}
        </div>
      </div>
      {missing.length > 0 && (
        <div>
          <div className="flex items-center gap-2 mb-2">
            <AlertCircle size={14} className="text-[#D97706]" />
            <span className="label-eyebrow">{L.missing} · {missing.length}</span>
          </div>
          <div className="flex flex-wrap gap-1.5">
            {missing.map((k, i) => (
              <span key={i} className="missing-kw text-xs" data-testid={`kw-missing-${i}`}>{k}</span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
